/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { Stack } from '@mui/material';
import { Chatbot, createChatBotMessage } from 'react-chatbot-kit';
import 'react-chatbot-kit/build/main.css';

import ActionProvider from './ActionProvider';
import ChatBotHeader from './ChatBotHeader';
import MyBootAvatar from './MyBootAvatar';
import UltraResponse from './UltraResponse';
import { useOutsideClick } from './useOutsideClick';

const CustomMessage = () => {
  return (
    <Stack style={{ alignItems: 'center', borderBottom: '1px dotted gray ' }}>
      New Chat Started
    </Stack>
  );
};

const MessageParser = ({ children, actions }: any) => {
  const parse = (message: any) => {
    actions.handleMessage(message);
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
        });
      })}
    </div>
  );
};

const ChatbotComponent: React.FC<{
  fileNames: string[];
  close: VoidFunction;
  botFrom: any;
  contractType: any;
}> = ({ fileNames, close, botFrom, contractType }) => {
  const ref = useOutsideClick(() => {
    close();
  });

  const saveMessages = (messages: any) => {
    localStorage.setItem('chat_messages', JSON.stringify(messages));
  };

  const loadMessages = () => {
    const lMessages = localStorage.getItem('chat_messages');
    if (lMessages && lMessages !== '') {
      const messages = JSON.parse(lMessages || '');
      return messages;
    }
  };

  const getPayload = () => {
    const lPayload = localStorage.getItem('chat_payload');
    if (lPayload && lPayload !== '') {
      const payload = JSON.parse(lPayload || '');
      return payload;
    } else {
      return [];
    }
  };

  const validateInput = (input: string) => {
    if (input) {
      return true;
    } else {
      return false;
    }
  };

  const config = {
    initialMessages: [
      createChatBotMessage(
        `Hi, I'm Ultra AI, Ask me your query related to this document`,
        {
          payload: { type: 'initial' },
        }
      ),
    ],
    inputPlaceholder: 'Type a message...',
    botName: 'Ultra AI',
    customStyles: {
      chatButton: {
        backgroundColor: '#005a9e',
      },
      botMessageBox: {
        backgroundColor: '#0078D4',
      },
    },
    state: {
      fileNames: fileNames,
      contractType: contractType,
      payload: getPayload(),
      botFrom: botFrom,
    },
    customComponents: {
      header: () => <ChatBotHeader closeBot={close} />,
      botAvatar: () => <MyBootAvatar type="bot" />,
      userAvatar: () => <MyBootAvatar type="user" />,
    },
    customMessages: {
      custom: (props: any) => <CustomMessage {...props} />,
    },
    widgets: [
      {
        widgetName: 'ultraResponse',
        widgetFunc: (props: any) => <UltraResponse {...props} />,
        props: {
          botMessage: null,
          citations: [],
          id: null,
        },
        mapStateToProps: [],
      },
      {
        widgetName: 'newMessage',
        widgetFunc: () => (
          <Stack>
            <p>New Chat Started</p>
          </Stack>
        ),
        props: {},
        mapStateToProps: [],
      },
    ],
  };

  return (
    <div ref={ref}>
      <Chatbot
        config={config}
        actionProvider={ActionProvider}
        messageParser={MessageParser}
        saveMessages={saveMessages}
        messageHistory={loadMessages()}
        validator={validateInput}
      />
    </div>
  );
};

export default ChatbotComponent;
